import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const StokInventoryPage = lazy(() => import('./pages/stok-inventory'))
const RiwayatMutasiStokPage = lazy(() => import('./pages/riwayat-mutasi-stok'))
const DetailLabelFgPage = lazy(() => import('./pages/detail-label-fg'))
const DashboardOperasionalPage = lazy(() => import('./pages/dashboard-operasional'))

/** Cluster C16 Inventory & Laporan — INV-01 stok gabungan, INV-02 riwayat mutasi (+ detail label FG dan cetak ulang stiker), INV-03 dashboard operasional. */
const inventoryReportsRoutes: RouteObject[] = [
  {
    path: 'inventory-reports',
    children: [
      { path: 'stok-inventory', element: <StokInventoryPage /> },
      { path: 'riwayat-mutasi-stok', element: <RiwayatMutasiStokPage /> },
      { path: 'riwayat-mutasi-stok/label/:code', element: <DetailLabelFgPage /> },
      { path: 'dashboard-operasional', element: <DashboardOperasionalPage /> }
    ]
  }
]

export default inventoryReportsRoutes
